import { z } from 'zod';

/**
 * Mirrors apps/api/src/modules/identity/http/platform-account.dto.ts (`createPlatformAdminSchema`): same bounds, same field names.
 * `confirmPassword` is the caller's OWN password, consumed by the API's re-authentication guard.
 */
export const createAdministratorFormSchema = z.object({
  email: z.string().trim().toLowerCase().email('Adresse e-mail invalide.').max(320),
  displayName: z.string().trim().min(2, 'Le nom doit contenir au moins 2 caractères.').max(120),
  reason: z.string().trim().min(10, 'Le motif doit contenir au moins 10 caractères.').max(500),
  confirmPassword: z.string().min(1, 'Saisissez votre mot de passe pour confirmer.').max(1024),
});
export type CreateAdministratorFormValues = z.infer<typeof createAdministratorFormSchema>;

/** Request of a promotion: who, why, and the requester's own password. */
export const requestPromotionFormSchema = z.object({
  userId: z.string().uuid(),
  reason: z.string().trim().min(10, 'Le motif doit contenir au moins 10 caractères.').max(500),
  confirmPassword: z.string().min(1, 'Saisissez votre mot de passe pour confirmer.').max(1024),
});
export type RequestPromotionFormValues = z.infer<typeof requestPromotionFormSchema>;
